import React, { Component } from 'react';
import Text from './../../Global/Modules/Text'

class Organsatie extends Component {

  render() {
    return (

      <Text url={window.location.pathname} />

    );
  }
}

export default Organsatie;



// WEBPACK FOOTER //
// ./src/components/Public/Pages/Organisatie.js